import { useMatch } from '@tanstack/react-router';

import { FloorPlansDashboard as EstateFloorPlansDashboard } from '@/features/estate-media/components/floor-plans-dashboard';
import { FloorPlansDashboard as ProjectFloorPlansDashboard } from '@/features/project-media/components/floor-plans-dashboard';

export const FloorPlans = () => {
  const estateMatch = useMatch({
    from: '/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout',
    shouldThrow: false,
  });
  const projectMatch = useMatch({
    from: '/_authenticated/_sidebar-layout/projects/$projectId/_dashboard-layout',
    shouldThrow: false,
  });

  if (estateMatch) {
    return <EstateFloorPlansDashboard />;
  }

  if (projectMatch) {
    return <ProjectFloorPlansDashboard />;
  }

  return null;
};
